export default {
  data() {
    return {
      showInner: false,
      selectedArr: [],
      confirmSelectedArr: [],
    };
  },

  methods: {
    onShow() {
      this.showInner = true;
    },

    onConfirm(e) {
      this.confirmSelectedArr = [...this.selectedArr];
      this.$emit('confirm', this.selectedArr, e);
    },

    onChange(arr) {
      this.selectedArr = arr;
      this.$emit('change', this.selectedArr);
    },
  },
};
